module.exports = __webpack_public_path__ + "614544be217ebbf38183d4e6aafe48c2.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-68.cur
// module id = 472
// module chunks = 0